export default {"src":"/_next/static/media/database.df607cbb.svg","height":79,"width":66};